import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, LinearProgress } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Parcel from "../../models/Parcel";
import $data from "../../services/$data";
import { variables } from "../../styles/abstract/variables";
import { DataContext } from "../DataContext";
import SelectInput from "../ui/SelectInput";
import TextInput from "../ui/TextInput";
import WKT from 'ol/format/WKT';
import { AppContext } from "../../AppContext";
const years = [
  { value: 2000, label: 2000 },
  { value: 2001, label: 2001 },
  { value: 2002, label: 2002 },
  { value: 2003, label: 2003 },
  { value: 2004, label: 2004 },
  { value: 2005, label: 2005 },
  { value: 2006, label: 2006 },
  { value: 2007, label: 2007 },
  { value: 2008, label: 2008 },
  { value: 2009, label: 2009 },
  { value: 2010, label: 2010 },
  { value: 2011, label: 2011 },
  { value: 2012, label: 2012 },
  { value: 2013, label: 2013 },
  { value: 2014, label: 2014 },
  { value: 2015, label: 2015 },
  { value: 2016, label: 2016 },
  { value: 2017, label: 2017 },
  { value: 2018, label: 2018 },
  { value: 2019, label: 2019 },
  { value: 2020, label: 2020 },
  { value: 2021, label: 2021 },
  { value: 2022, label: 2022 },
  { value: 2023, label: 2023 },
  { value: 2024, label: 2024 },
  { value: 2025, label: 2025 }
];

function CreateApplication({onRefresh, parcels, open, onClose}) {
	const {user} = useContext(AppContext);
	const {projectData, onShowSuccess, onUpdateProjects} = useContext(DataContext); 

	const [loading, setLoading] = useState(false);
	
	const [state, setState] = useState({
    parcel: undefined,
    year: undefined
	})




	const onSubmit = async () => {
		setLoading(true);

		try {
      let result = await $data.createApplication({parcel: state.parcel.id, years: [state.year]});
      await onRefresh();
      onClose();
		} catch(e) {
			console.log(e)
		} finally {
			setLoading(false);
		}
	}

  const generateYears = () => {
    if(!state.parcel) return [];

    let parcelYears = state.parcel.status.map(obj => obj.year);

    return years.filter(obj => parcelYears.indexOf(obj.value) === -1);
  }

	return (
		<Dialog fullWidth maxWidth="sm" PaperProps={{className: 'co-background-white'}} open={open} onClose={onClose}>
			
			<DialogTitle color="primary">Create application</DialogTitle>
			<form onSubmit={(evt) => {evt.preventDefault(); onSubmit()}}>
				<DialogContent>
          <SelectInput name="Select parcel" value={state.parcel} items={parcels.map(p => ({value: p, label: p.name}))} onChange={(evt) => setState(current => ({...current, parcel: evt.target.value}))} />

          <SelectInput name="Select year of application" value={state.year} items={generateYears()} onChange={(evt) => setState(current => ({...current, year: evt.target.value}))} />
				</DialogContent>
				<DialogActions>
					<Button disabled={loading} style={{lineHeight: 'unset'}} color="error" onClick={onClose}>Cancel</Button>
					<Button disabled={loading || !state.parcel || !state.year} type="submit" style={{lineHeight: 'unset'}} color="primary">Create</Button>
					
				</DialogActions>
			</form>
			{loading && <LinearProgress color="primary" />}
		</Dialog>
	)
}

export default CreateApplication;